import React, {useState, useRef, useEffect} from "react";
import {useSelector} from "react-redux";
import {useActivate, useUnactivate} from "react-activation";
import {message, Modal, Breadcrumb, Space, Button, Form, Row, Col, Input, Table} from "antd";
import {FileAddOutlined, DeleteOutlined, CloseCircleOutlined, FileSearchOutlined, FileTextOutlined} from "@ant-design/icons";
import ChuangShiOS from "chuangshi-os-website-component";

import Application from "../../common/Application";

import Style from "./Index.module.css";

const CityIndex = (props) => {
    const store = useSelector((store) => store);
    const [form] = Form.useForm();
    const request = useRef(false);
    const [isLoad, setIsLoad] = useState(false);
    const [isError, setIsError] = useState(false);
    const [tableHeight, setTableHeight] = useState(0);
    const [cityPageIndex, setCityPageIndex] = useState(1);
    const [cityPageSize, setCityPageSize] = useState(store.main.pageSize);
    const [cityIdList, setCityIdList] = useState([]);
    const [cityTotal, setCityTotal] = useState(0);
    const [cityList, setCityList] = useState([]);

    useEffect(() => {
        if (store.main.userName) {
            ChuangShiOS.Notification.emit("main_menu_active", {url: "/city/index"});

            handleSearchCity();
        }

        //eslint-disable-next-line
    }, [store.main.userName]);

    useEffect(() => {
        handleLoadCity(cityPageIndex, store.main.pageSize);

        //eslint-disable-next-line
    }, [store.main.pageSize]);

    useActivate(() => {
        ChuangShiOS.Notification.emit("main_set_scroll_top", {});

        handleLoadCity(cityPageIndex, cityPageSize);
    });

    useUnactivate(() => {
        ChuangShiOS.Notification.emit("main_get_scroll_top", {});
    });

    const handleSearchCity = () => {
        handleLoadCity(1, cityPageSize);
    };

    const handleLoadCity = (cityPageIndex, cityPageSize) => {
        if (request.current) {
            return;
        }
        request.current = true;

        setIsLoad(true);

        let data = form.getFieldsValue();
        data.pageIndex = cityPageIndex;
        data.pageSize = cityPageSize;

        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/city/business/website/v1/list",
            data: data,
            success: (response) => {
                setCityPageIndex(cityPageIndex);
                setCityPageSize(cityPageSize);
                setCityIdList([]);
                setCityTotal(response.data.total);
                setCityList(response.data.list);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {
                request.current = false;

                setIsLoad(false);
                setIsError(
                    typeof response.data == "undefined" ||
                        response.data.total == "undefined" ||
                        response.data.total == null ||
                        response.data.list == "undefined" ||
                        response.data.list == null
                );
            },
        });
    };

    const handleAddCity = () => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/city/add",
        });
    };

    const handleEditCity = (cityId) => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/city/edit/" + cityId,
        });
    };

    const handleDelCity = () => {
        if (cityIdList.length == 0) {
            return;
        }

        if (request.current) {
            return;
        }

        Modal.confirm({
            title: "是否确认操作？",
            content: "本次数据操作后将无法恢复",
            okText: "确认",
            okType: "danger",
            okButtonProps: {
                icon: <DeleteOutlined />,
            },
            cancelText: "取消",
            cancelButtonProps: {
                icon: <CloseCircleOutlined />,
            },
            onOk: () => {
                if (request.current) {
                    return;
                }
                request.current = true;

                setIsLoad(true);

                message.loading({
                    content: "正在加载",
                    key: "isLoad",
                    duration: 0,
                });

                ChuangShiOS.Util.request(props, {
                    url: Application.host + "/windeal/city/business/website/v1/delete",
                    data: {
                        cityIdList: cityIdList,
                    },
                    success: (response) => {
                        message.success({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                        setCityIdList([]);

                        handleLoadCity(cityPageIndex, cityPageSize);
                    },
                    error: (response) => {
                        message.error({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                    },
                    complete: (response) => {},
                });
            },
        });
    };

    const handleChangeCityIdList = (cityIdList) => {
        setCityIdList(cityIdList);
    };

    const handleChangeCityPagination = (cityPageIndex, cityPageSize) => {
        handleLoadCity(cityPageIndex, cityPageSize);
    };

    return (
        <div className={Style.page}>
            <div className={Style.header}>
                <div className={Style.header_title}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <span>首页</span>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span>{store.main.menuName}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div className={Style.header_title_text}>{store.main.sidebarName}</div>
                </div>
                <div className={Style.header_button}>
                    <Space>
                        <Button.Group>
                            <Button icon={<FileAddOutlined />} size="large" onClick={handleAddCity}>
                                新增
                            </Button>
                            <Button loading={isLoad} disabled={cityIdList.length == 0} icon={<DeleteOutlined />} size="large" onClick={handleDelCity}>
                                删除
                            </Button>
                        </Button.Group>
                        <Button loading={isLoad} icon={<FileSearchOutlined />} type="primary" size="large" onClick={handleSearchCity}>
                            查询
                        </Button>
                    </Space>
                </div>
            </div>
            <ChuangShiOS.Content className={Style.content} isLoad={isLoad} isEmpty={false} isError={isError} isScroll={store.main.isFixedContent}>
                <Form form={form}>
                    <Row>
                        <Col span={6}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="城市名称"
                                labelAlign={"left"}
                                name="cityName"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入城市名称",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入城市名称" onPressEnter={handleSearchCity} />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="城市代码"
                                labelAlign={"left"}
                                name="cityCode"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入城市代码",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入城市代码" onPressEnter={handleSearchCity} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <div
                    ref={(ref) => {
                        if (ref != null && tableHeight == 0 && tableHeight != ref.clientHeight) {
                            setTableHeight(ref.clientHeight);
                        }
                    }}
                    className={store.main.isFixedContent ? Style.card_table : null}
                >
                    <Table
                        size="small"
                        rowKey={(record) => record.cityId}
                        columns={[
                            {
                                title: "省份名称",
                                dataIndex: "provinceName",
                            },
                            {
                                title: "城市名称",
                                dataIndex: "cityName",
                            },
                            {
                                title: "城市代码",
                                dataIndex: "cityCode",
                            },
                            {
                                title: "城市排序",
                                dataIndex: "citySort",
                            },
                            {
                                title: "操作",
                                width: 150,
                                render: (text, record, recordIndex) => (
                                    <Space>
                                        <Button icon={<FileTextOutlined />} size="default" onClick={() => handleEditCity(record.cityId)}>
                                            修改
                                        </Button>
                                    </Space>
                                ),
                            },
                        ]}
                        dataSource={cityList}
                        rowSelection={{
                            fixed: true,
                            selectedRowKeys: cityIdList,
                            onChange: handleChangeCityIdList,
                        }}
                        scroll={store.main.isFixedContent ? {y: tableHeight - 130} : {}}
                        pagination={{
                            size: "default",
                            showQuickJumper: true,
                            showSizeChanger: true,
                            current: cityPageIndex,
                            pageSize: cityPageSize,
                            total: cityTotal,
                            showTotal: (total, range) => "显示" + range[0] + "到" + range[1] + "条,共有" + total + "条",
                            onChange: handleChangeCityPagination,
                            onShowSizeChange: handleChangeCityPagination,
                        }}
                    />
                </div>
            </ChuangShiOS.Content>
            <div className={Style.footer}></div>
        </div>
    );
};

CityIndex.propTypes = {};

CityIndex.defaultProps = {};

export default CityIndex;
